import { eventsApiSlice } from '../../../../../store/eventApiSlice';

export const extendedApiSlice = eventsApiSlice
  .enhanceEndpoints({ addTagTypes: ['event-admin-auth'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      updateAccountDetails: builder.mutation({
        query: ({ data, id }) => ({
          url: `auth/account_details`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'auth-account-details' }],
      }),
      getAccountDetails: builder.query({
        query: () => ({
          url: 'auth/account_details',
          method: 'get',
        }),
        providesTags: ['auth-account-details'],
      }),
      getPublicAccountDetails: builder.query({
        query: (publicId) => ({
          url: `auth/account_details_public/${publicId}`,
          method: 'GET',
        }),
      }),
      getAccountDetailsForLogin: builder.query({
        query: () => ({
          url: 'auth/account_details',
          method: 'get',
          useDefaultErrorHandler: false,
        }),
      }),
      getRegions: builder.query({
        query: () => ({
          url: 'compliance/regions',
          method: 'get',
          useDefaultErrorHandler: false,
        }),
      }),
    }),
  });

export const {
  useUpdateAccountDetailsMutation,
  useGetAccountDetailsQuery,
  useGetPublicAccountDetailsQuery,
  useGetAccountDetailsForLoginQuery,
  useGetRegionsQuery,
} = extendedApiSlice;
